global.$ = global.jQuery = require('jquery');

require('slick-carousel');
require('magnific-popup');
require('./apng-canvas');
require('./aishipr-default');
require('./aishipr-fix');
require('./register-page');
require('./ashiato');
require('./address-edit');
require('./aishipr-breadcrumb');
require('./heading');

require('./common');
require('./top');
